import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Loading";
import { PaginationLimit } from "../../Config";
import Config from "../../Config";
import { HiEye, HiOutlineDownload } from "react-icons/hi";
import { RiContactsFill, RiSendPlaneFill, RiSecurePaymentFill, RiDeviceRecoverFill } from "react-icons/ri";
import { BsBellFill } from "react-icons/bs";
import { FaFileExport, FaUserNurse } from "react-icons/fa";
import { MdOutlineDocumentScanner, MdArrowUpward, MdArrowDownward, MdAdd, MdPayment, MdEdit,MdOutlineCloudUpload,MdOutlineCloudDownload } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";

import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdPersonAddAlt1,
  MdModeEdit,
} from "react-icons/md";

const Table = ({
  ApiData,
  setSelectedItem,
  setOpenUpdateStatusModel,
  setOpenViewModel,
  //makePaymentModel,
  makeLCPaymentMutate,
  makeAFPaymentMutate,
  setOpenUploadCertificateModel,
  setOpenLostCertificateModel,
  setOpenFeeModel,
  setOpenOtherServicesModel,
  openConsentModel,
  generateCertificate,
  makePaymentMutate,
  setAdminLCMutate,
  setAdminLCModel,
  annualFeesDetailsPostMutate,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //const [openUploadCertificateModel, setOpenUploadCertificateModel] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);
  

  const goToCustomerForm = (item) => {
    // navigate(`/customer-form/${item.customerId}/${item.id}`);
    window.open(`/customer-form/${item.customerId}/${item.id}`, "_blank");
  };

  const goToFilledCustomerForm = (item) => {
    navigate(`/edit-customer-form/${item.customerId}/${item.id}`);
  };


  const searchForCustomer = (email) => {
    window.open(`/search/${email}`, "_blank");
  };

  const [data, setData] = useState([
    {
      assocName: "",
      assocNo: "",
      email: "",
      status: "",
      typeOfReg: "",
      typeOfRegLabel: "",
      date: "",
      //nurse: "",
    },
  ]);

  const openModel = (item) => {
    //setOpenUpdateStatusModel(true);
    setSelectedItem(item);
    openConsentModel(item);
  };

  const downloadCertificate = (item) => {
    return Config.docUrl + item.certificateName;
  };
  

  const openViewModelHandler = (item) => {
    setSelectedItem(item);
    setOpenViewModel(true);
  };

  const openAdminLCHandler = (item) => {
    setSelectedItem(item);
    setAdminLCMutate(item);
  };

  const edit = (item) => {
    navigate(`/edit-regapp/${item.id}`);

  };

  const uploaddocs = (item) => {
    navigate(`/submit-docs/${item.id}`);

  };

  const uploadCertificate = (item) => {
    setSelectedItem(item);
    setOpenUploadCertificateModel(true);
  }

  const openAnnualFeeModel = (e) => {
    setSelectedItem(e);
    setOpenFeeModel (true);
  };

  const openLosCertificateModel = (e) => {
    setSelectedItem(e);
    setOpenLostCertificateModel (true);
  };

  const openServicesModel = (e) => {
    console.log(e);
    setSelectedItem(e);
    setOpenOtherServicesModel(true);
  };

  // const generateCertificate = (item) => {
  //   setSelectedItem(item);
  //   generateCertificate(item);
  // }
  
  const makePayment = (item) => {
    setSelectedItem(item);
    //makePaymentModel(true);
    makePaymentMutate(item);

  };

  const makeLCPayment = (item) => {
    setSelectedItem(item);
    makeLCPaymentMutate(item);

  };

  const makeAFPayment = (item) => {
    setSelectedItem(item);
    makeAFPaymentMutate(item);

  };

  const generateAFControlNo = (item) => {
    setSelectedItem(item);
    annualFeesDetailsPostMutate(item);
    setOpenFeeModel(true);

  };

  const ActionBtns = (item) => {
    return (
      <ActionBtnWrapper>
        <Btn
          title="View All Details"
          onClick={() => openViewModelHandler(item)}
        >
          <HiEye className="text-gray-700" />
        </Btn>
        

      </ActionBtnWrapper>
    );
  };

  const getStatus = (status) => {
    if (status == 0) {
      return <ErrorBadge>{"Not Submitted"}</ErrorBadge>;
    }
    if (status == 1) {
      return <PendingBadge>{"Pending Docs"}</PendingBadge>;
    }if (status == 2) {
      return <PendingBadge>{"Pending Payment"}</PendingBadge>;
    } 
    if (status == 3) {
      return <InprogressBadge>Inprogress</InprogressBadge>;
    } 
    if (status == 4) {
      return <InprogressBadge>{"Approved By Asst"}</InprogressBadge>;
    } 
    if (status == 5) {
      return <SuccessBadge>Completed</SuccessBadge>;
    } 
    if (status == 6) {
      return <SuccessBadge>{"Certificate Issued"}</SuccessBadge>;
    }
    if (status == 7) {
      return <PendingBadge>{"Notice Issued"}</PendingBadge>;
    }
    if (status == 8) {
      return <ErrorBadge>{"Cancelled"}</ErrorBadge>;
    }
    else {
      return <ErrorBadge>Rejected</ErrorBadge>;
    }
  };


  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        assocName: item.assocName,
        assocNo: item.assocNo,
        email: item.email,
        date: moment(item.date).format("DD-MM-YYYY"),
        typeOfReg: item.typeOfReg,
        typeOfRegLabel: item.typeOfRegLabel,
        typeOfAssoc: item.typeOfAssoc,
        typeOfAssocLabel: item.typeOfAssocLabel,
        region: item.region,
        regionLabel: item.regionLabel,
        district: item.district,
        districtLabel: item.districtLabel,
        status: getStatus(item.status),
        action: ActionBtns(item),
      }));

      setData(tempData);
    }
  }, [ApiData]);

  const columns = React.useMemo(() => {
    let cols = [
      
      {
        Header: "Assoc No",
        accessor: "assocNo",
      },
      {
        Header: "Assoc Name",
        accessor: "assocName",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Type Of Reg",
        accessor: "typeOfRegLabel",
      },
      {
        Header: "Type Of Assoc",
        accessor: "typeOfAssocLabel",
      },
      {
        Header: "Region",
        accessor: "regionLabel",
      },
      {
        Header: "District",
        accessor: "districtLabel",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];

    return cols;
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setPageSize(PaginationLimit);
  }, []);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </CustomTable>

      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <select
            className="w-32 text-gray-500 text-sm"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[10, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show rows: {pageSize}
              </option>
            ))}
          </select>

          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <MdKeyboardArrowLeft className=" text-xl " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <MdKeyboardArrowRight className="text-xl " />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const EmailBtn = tw.button`cursor-pointer hover:text-blue-700 hover:underline `;

const UserImageWrapper = tw.div` flex items-center space-x-2`;
const UserImage = tw.img`w-5 h-5 rounded-full overflow-hidden`;

const ActionBtnWrapper = tw.div`flex items-center space-x-3`;

const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;

const CustomTable = tw.table` w-full`;
const Thead = tw.thead`border-b`;
const Tbody = tw.tbody`border-b`;
const Tr = tw.tr`border-b rounded-md overflow-hidden `;
const Th = tw.th`text-left text-sm p-3 font-medium text-gray-500  `;
const Td = tw.td`p-3 text-sm`;

const SuccessBadge = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-28 h-7 flex items-center justify-center rounded`;
const PendingBadge = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-28 h-7 flex items-center justify-center rounded`;
const InprogressBadge = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-28 h-7 flex items-center justify-center rounded`;
const ErrorBadge = tw.div`bg-red-300 text-white-700 text-xs border-red-300 border w-28 h-7 flex items-center justify-center rounded`;
export default Table;
